<template>
  <div class="news-detail">
    <img class="news-img" :src="newsData.imgPath" />
    <div class="news-header">
      <div class="news-title">{{ newsData.title }}</div>
      <div class="news-date">{{ newsDate }}</div>
    </div>
    <div class="news-content" v-html="newsData.detail"></div>
    <div class="news-clear" />
    <div class="news-back">
      <div class="temple-button-text" @click="back">回上一頁</div>
    </div>
    <div class="news-clear" />
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'NewsItemDetail',
  props: {
    newsData: {
      id: String,
      title: String,
      subTitle: String,
      imgPath: String,
      detail: String,
      date: String,
    },
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
  },
  computed: {
    newsDate: function() {
      return moment(String(this.newsData.date)).format('YYYY/MM/DD');
    },
  },
};
</script>

<style scoped>
.news-detail {
  text-align: left;
}

.news-header {
  margin-top: 10px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #000000;
}

.news-title {
  font-size: 18px;
  text-align: left;
  height: 30px;
  font-weight: bold;
  color: #000000;
}

.news-date {
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  color: #828282;
  text-align: right;
}

.news-img {
  margin-top: 10px;
  max-width: 60vw;
}

.news-content {
  margin-top: 30px;
  font-size: 16px;
  text-align: left;
  line-height: 26px;
}

.news-clear {
  width: 100%;
  height: 75px;
  clear: both;
}

.news-back {
  align-items: center;
  display: flex;
  justify-content: center;
}

@media (max-width: 767px) {
  .news-detail {
    text-align: center;
  }

  .news-header {
    display: block;
    height: auto;
  }

  .news-title {
    height: auto;
  }

  .news-date {
    height: auto;
  }

  .news-img {
    width: calc(100vw - 40px);
    max-width: none;
  }
}
</style>
